import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { getFlow } from "../services/flowServices"
import { formatYearToDatabase } from "../views/Flow"


export function useFlow(){
    const flowSelected = useSelector((state) => state.global.flowSelected)
    const store = useSelector((state) => state.global.filtersSelected.store)
    const period = useSelector((state) => state.global.filtersSelected?.period.id)
    const hfb = useSelector((state) => state.global.filtersSelected?.hfb)
    const pa = useSelector((state) => state.global.filtersSelected.pa)
    const pcd = useSelector((state) => state.global.filtersSelected.pcd)
    const department = useSelector((state) => state.global.filtersSelected.department)
    const categoryProductivity = useSelector((state) => state.global.filtersSelected.categoryProductivity)
    const monthSelected = useSelector((state) => state.global.filtersSelected?.month)
    const year = useSelector((state) => state.global.lastDateData?.year);
    const defaultPa =  useSelector((state) => state.filters.pas[0])

    const [isLoading, setIsLoading] = useState(true)
    const [flow, setFlow] = useState([])
    useEffect(()=>{
        setIsLoading(true)
        if(flowSelected && store && hfb && pcd && period !== null && department && categoryProductivity){
          const params = {
            store:store.id, 
            hfb:hfb.id, 
            period: period,
            ...(flowSelected.id === 8  ? {PCD: pcd.id} : {}),
            ...(flowSelected.id !== 1  ? {pa: pa ? pa.id : defaultPa.id} : {}),
            department: department,
            productivityCategory: categoryProductivity,
            ...(flowSelected.id === 7  ? {
              month: monthSelected,
              year: formatYearToDatabase(monthSelected,year)} : {})
          }
          getFlow(flowSelected.id, params).then ( flow => setFlow(flow)).finally(() => setIsLoading(false))
        }
      },[flowSelected, pcd, store, hfb, period, pa, categoryProductivity, department, monthSelected, defaultPa.id, year])

    return {flow, isLoading}
}